// extracted by mini-css-extract-plugin
export default {"additional":"rj5d_"};